<template>
    <div
        :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']"
        ref="box"
        @scroll.native="onScroll"
    >
        <!-- <div class="header acea-row row-center-wrapper" :style="'opacity:' + opacity" ref="header">
            <div class="item" :class="navActive === index ? 'on' : ''" v-for="(item, index) in navList" :key="index" @click="asideTap(index)">
                {{ item }}
            </div>
        </div> -->
        <div id="title0">
            <product-con-swiper
                :img-urls="storeInfo.slider_image"
                :videoline="storeInfo.video_link"
            ></product-con-swiper>
            <div class="wrapper contTop">
                <div class="goodsCon_title view_shadow">
                    <div class="goodsCon_title-name" style="margin-top: 0;">
                        {{ storeInfo.store_name }}
                    </div>
                    <div
                        class="goodsCon_title-price"
                        style="margin-top: 0.16rem;"
                    >
                        <div class="font-color-red">
                            {{ shop_type == 3 ? "" : "￥"
                            }}<span class="num font-color-red"
                                >{{ storeInfo.price
                                }}{{ shop_type == 3 ? "积分" : "" }}</span
                            >
                        </div>
                        <div v-if="shop_type != 3">
                            ￥{{ storeInfo.ot_price }}
                        </div>
                        <div v-if="shop_type == 3" style="flex:1"></div>
                        <div style="flex:1" v-if="shop_type != 3">
                            <span class="span" v-if="gains != 0">
                                <img
                                    src="@assets/images/icon_up.png"
                                    alt=""
                                    v-if="gains == 1"
                                />
                                <img
                                    src="@assets/images/icon_down.png"
                                    alt=""
                                    v-if="gains == 2"
                                />
                                <div style="color:#D01112">
                                    {{ gains_num }}%
                                </div>
                            </span>
                        </div>
                        <div>
                            销量:{{ storeInfo.fsales }}{{ storeInfo.unit_name }}
                        </div>
                    </div>
                </div>
                <!-- <div class="goodsCon_guarantee view_shadow">
                    <span>保障</span>
                    <div>
                        <div>正</div>
                        <div>正品保障</div>
                    </div>
                    <div>
                        <div>保</div>
                        <div>平台保障</div>
                    </div>
                    <div>
                        <div>假</div>
                        <div>假一赔十</div>
                    </div>
                </div> -->
                <div
                    class="goodsCon_attr view_shadow"
                    @click="selecAttrTap"
                    v-if="attr.productAttr.length"
                >
                    <div class="goodsCon_attr-left">{{ attrTxt }}：</div>
                    <span class="goodsCon_attr-cont">{{ attrValue }}</span>
                    <div
                        class="goodsCon_attr-right iconfont icon-jiantou "
                    ></div>
                </div>
                <!-- <div class="goodsCon_attr view_shadow" @click="couponTap" v-if="couponList.length">
                    <div class="goodsCon_attr-left" style="color:#333">领取优惠券：</div>
                    <div class="iconfont icon-jiantou"></div>
                </div> -->
            </div>
        </div>
        <!-- <div class="view_shadow_margin_top">
            <div class="userEvaluation " style="margin:0;" id="title1">
                <div class="title acea-row row-between-wrapper">
                    <div>用户评价({{ replyCount }})</div>
                    <div class="praise" @click="goUrl(id)">
                        <span class="font-color-red">{{ replyChance }}%</span>好评率<span class="iconfont icon-jiantou"></span>
                    </div>
                </div>
                <user-evaluation :reply="reply"></user-evaluation>
            </div>
        </div> -->
        <!--         
        <div class="view_shadow_margin_top">
            <div class="superior" v-if="goodList.length > 0" id="title2">
                <div class="title acea-row row-center-wrapper">
                    <img src="@assets/images/ling.png" />
                    <div class="titleTxt">优品推荐</div>
                    <img src="@assets/images/ling.png" />
                </div>
                <template>
                    <div class="slider-banner banner">
                        <swiper :options="swiperRecommend">
                            <swiper-slide v-for="(item, index) in goodList" :key="index">
                                <div class="list acea-row row-middle">
                                    <div class="item" v-for="val in item.list" :key="val.image" @click="goGoods(val)">
                                        <div class="pictrue">
                                            <img :src="val.image" />
                                            <span class="pictrue_log pictrue_log_class" v-if="val.activity && val.activity.type === '1'">秒杀</span>
                                            <span class="pictrue_log pictrue_log_class" v-if="val.activity && val.activity.type === '2'">砍价</span>
                                            <span class="pictrue_log pictrue_log_class" v-if="val.activity && val.activity.type === '3'">拼团</span>
                                        </div>
                                        <div class="name line1">{{ val.store_name }}</div>
                                        <div class="money font-color-red">¥{{ val.price }}</div>
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                        </swiper>
                    </div>
                </template>
            </div>
        </div> -->

        <div class="htmlTitle">
            <div :class="contShow == 0 ? 'on' : ''" @click="contShow = 0">
                商品详情
            </div>
            <div :class="contShow == 1 ? 'on' : ''" @click="contShow = 1">
                商品评价
            </div>
        </div>

        <div
            class="html"
            v-html="storeInfo.description"
            v-if="contShow == 0"
        ></div>
        <div class="replyConter" v-if="contShow == 1">
            <div class="userEvaluation " style="margin:0;" id="title1">
                <user-evaluation :reply="reply"></user-evaluation>
            </div>
            <div
                @click="goUrl(id)"
                style="margin: 0 auto;width: 2rem;height: 0.8rem;border: 0.01rem solid #eee;line-height: 0.8rem;font-size: 0.28rem;color: #999;text-align: center;border-radius: 0.8rem;"
            >
                查看更多
            </div>
        </div>

        <!-- <div class="view_shadow_margin">
            <div class="product-intro" id="title3">
                <div class="title">
                    产品介绍
                </div>
                <div class="conter" v-html="storeInfo.description"></div>
            </div>
        </div> -->

        <div style="height:1.2rem;"></div>
        <div
            class="footer acea-row row-between-wrapper"
            :style="{ 'padding-left': shop_type == 2 ? '0.7rem' : '' }"
        >
            <!-- <router-link class="item" to="/">
                <div class="iconfont ">
                    <img src="../../assets/newImg/home.png" alt="" />
                </div>
                <div>首页</div>
            </router-link> -->
            <div class="item" @click="setCollect">
                <div
                    class="iconfont"
                    :class="
                        storeInfo.userCollect
                            ? 'icon-shoucang1'
                            : 'icon-shoucang'
                    "
                ></div>
                <div>收藏</div>
            </div>
            <div class="item" @click="callServe">
                <div class="iconfont icon-kefu"></div>
                <div>客服</div>
            </div>
            <div
                @click="goCart"
                class="item animated"
                :class="animated === true ? 'bounceIn' : ''"
                v-if="shop_type != 2"
            >
                <div class="iconfont icon-gouwuche1">
                    <span class="num bg-color-red" v-if="CartCount > 0">{{
                        CartCount
                    }}</span>
                </div>
                <div>购物车</div>
            </div>
            <div class="bnt acea-row">
                <div
                    class="joinCart"
                    @click="joinCart"
                    v-if="shop_type == 1 || shop_type == 3"
                >
                    加入购物车
                </div>
                <div
                    class="buy"
                    @click="tapBuy"
                    v-if="attr.productSelect.stock > 0"
                    :style="{ width: shop_type == 2 ? '5rem' : '' }"
                >
                    {{ shop_type == 3 ? "立即兑换" : "立即购买" }}
                </div>
                <div
                    class="buy bg-color-hui"
                    :style="{ width: shop_type == 2 ? '5rem' : '' }"
                    v-else
                >
                    已售罄
                </div>
            </div>
        </div>
        <!-- <Share-red-packets :priceName="priceName" v-on:changeFun="changeFun" v-if="priceName !== 0"></Share-red-packets> -->
        <CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop>

        <Product-window
            v-on:changeFun="changeFun"
            :attr="attr"
        ></Product-window>

        <StorePoster
            v-on:setPosterImageStatus="setPosterImageStatus"
            :posterImageStatus="posterImageStatus"
            :posterData="posterData"
        ></StorePoster>

        <ShareInfo
            v-on:setShareInfoStatus="setShareInfoStatus"
            :shareInfoStatus="shareInfoStatus"
        ></ShareInfo>
        <!-- <div class="generate-posters acea-row row-middle" :class="posters ? 'on' : ''">
            <div class="item" v-if="weixinStatus === true" @click="setShareInfoStatus">
                <div class="iconfont icon-weixin3"></div>
                <div class="">发送给朋友</div>
            </div>
            <div class="item" @click="setPosterImageStatus">
                <div class="iconfont icon-haibao"></div>
                <div class="">生成海报</div>
            </div>
        </div> -->
        <div
            class="mask"
            @touchmove.prevent
            @click="listenerActionClose"
            v-show="posters"
        ></div>
        <div class="geoPage" v-if="mapShow">
            <iframe
                width="100%"
                height="100%"
                frameborder="0"
                scrolling="no"
                :src="
                    'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
                        system_store.latitude +
                        ',' +
                        system_store.longitude +
                        '&referer=' +
                        mapKey
                "
            >
            </iframe>
        </div>
    </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import ProductConSwiper from "@components/ProductConSwiper";
import UserEvaluation from "@components/UserEvaluation";
import ShareRedPackets from "@components/ShareRedPackets";
import CouponPop from "@components/CouponPop";
import ProductWindow from "@components/ProductWindow";
import StorePoster from "@components/StorePoster";
import ShareInfo from "@components/ShareInfo";
import { goShopDetail } from "@libs/order";
import debounce from "lodash.debounce";
import {
    getProductDetail,
    postCartAdd,
    getCartCount,
    getProductCode,
    storeListApi,
} from "@api/store";
import {
    getCoupon,
    getCollectAdd,
    getCollectDel,
    getUserInfo,
    queryCard,
} from "@api/user";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import { imageBase64 } from "@api/public";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import store from "@/store";
let NAME = "GoodsDetail";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
    name: NAME,
    components: {
        swiper,
        swiperSlide,
        ProductConSwiper,
        UserEvaluation,
        ShareRedPackets,
        CouponPop,
        ProductWindow,
        StorePoster,
        ShareInfo,
    },
    data() {
        return {
            shareInfoStatus: false,
            weixinStatus: false,
            mapShow: false,
            mapKey: "",
            posterData: {
                image: "",
                title: "",
                price: "",
                code: "",
            },
            posterImageStatus: false,
            animated: false,
            coupon: {
                coupon: false,
                list: [],
            },
            attr: {
                cartAttr: false,
                productAttr: [],
                productSelect: {},
            },
            isOpen: false, //是否打开属性组件
            productValue: [],
            id: 0,
            storeInfo: {},
            couponList: [],
            attrTxt: "请选择",
            attrValue: "",
            cart_num: 1, //购买数量
            replyCount: "",
            replyChance: "",
            reply: [],
            priceName: 0,
            CartCount: 0,
            posters: false,
            banner: [{}, {}],
            swiperRecommend: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                autoplay: false,
                loop: false,
                speed: 1000,
                observer: true,
                observeParents: true,
            },
            goodList: [],
            system_store: {},
            storeSelfMention: true,
            storeItems: {},
            activity: [],
            navList: [],
            lock: false,
            navActive: 0,
            opacity: 0,
            is_real_name: 0,
            contShow: 0,
            shop_type: 1,
            gains: 0,
            gains_num: 0,
            isShow: false,
        };
    },
    computed: mapGetters(["isLogin"]),
    watch: {
        $route(n) {
            if (n.name === NAME) {
                this.id = n.query.id;
                this.storeInfo.slider_image = [];
                this.productCon();
            }
        },
    },
    updated() {
        // window.scroll(0, 0);
    },
    mounted() {
        console.log("meta=>", this.$store.state.app);
        localStorage.setItem("historyAppShareLink", location.href);
        console.log(12333);
        console.log(this.$route.query);
        console.log("isLogin1===>", this.isLogin);
        localStorage.setItem("backUrl", location.href);
        localStorage.setItem("spread", this.$route.query.uid);
        if (this.$route.query.type == 1 && store.state.app.token) {
            this.$router.replace(
                `/detail/${this.$route.query.id}?shop_type=${
                    this.$route.query.shop_type
                }&uid=${this.$route.query.uid}`
            );
            return;
        }
        if (this.$route.query.token && this.$route.query.token.length > 0) {
            let time = this.$route.query.expires_time || "";
            let token = this.$route.query.token || "";
            console.log(time);
            const datas = {
                token: token,
                expires_time: time,
            };
            this.$store.commit("LOGIN", datas);
            this.bankCard();
        }
        console.log("isLogin2===>", this.isLogin);
        document.addEventListener("scroll", this.onScroll, false);
        this.id = this.$route.query.id || "";
        this.storeInfo.slider_image = [];
        this.shop_type = this.$route.query.shop_type || 1;
        this.productCon();
        this.coupons();
        window.addEventListener("scroll", this.handleScroll);
        // this.getList();
    },
    methods: {
        goUrl(id) {
            if (this.$route.query.type == 1) {
                this.$router.replace(
                    `/detail/${this.$route.query.id}?shop_type=${
                        this.$route.query.shop_type
                    }`
                );
                return;
            }
            let goData = {
                type: "evaluate",
            };
            window.ReactNativeWebView &&
                window.ReactNativeWebView.postMessage(JSON.stringify(goData));
            this.$router.push(`/evaluate_list/${id}`);
        },
        goCart() {
            if (this.$route.query.type == 1) {
                this.$router.replace(
                    `/detail/${this.$route.query.id}?shop_type=${
                        this.$route.query.shop_type
                    }`
                );

                return;
            }
            let goData = {
                type: "cart",
            };
            window.ReactNativeWebView &&
                window.ReactNativeWebView.postMessage(JSON.stringify(goData));
        },
        goEvaluate() {
            const isLogin = this.isLogin;
            if (!isLogin) {
                let goData = {
                    type: "notLogin",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
            } else {
                this.$router.push({
                    path: "/goEvaluate/" + this.$route.query.id,
                });
            }
        },

        // 商品详情跳转
        goDetail(item) {
            if (item.type === "1") {
                this.$router.push({
                    path:
                        "/activity/seckill_detail/" +
                        item.id +
                        "/" +
                        item.time +
                        "/1",
                });
            } else if (item.type === "2") {
                this.$router.push({
                    path: "/activity/dargain_detail/" + item.id,
                });
            } else {
                this.$router.push({
                    path: "/activity/group_detail/" + item.id,
                });
            }
        },
        // 获取门店列表数据
        getList() {
            let data = {
                latitude: localStorage.getItem(LATITUDE) || "", //纬度
                longitude: localStorage.getItem(LONGITUDE) || "", //经度
                page: 1,
                limit: 10,
            };
            storeListApi(data)
                .then((res) => {
                    this.storeItems = res.data.list[0];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleScroll() {
            let top =
                document.body.scrollTop || document.documentElement.scrollTop;
            let opacity = top / 350;
            opacity = opacity > 1 ? 1 : opacity;
            this.opacity = opacity;
        },
        asideTap(a) {
            this.$nextTick(() => {
                let index = a;
                this.navActive = index;
                if (!this.goodList.length && index === 2) {
                    index = 3;
                }
                let element = document.querySelector("#title" + index);
                const top =
                    element.offsetTop -
                    this.$refs.header.offsetHeight -
                    window.scrollY;
                this.lock = true;
                window.scrollBy({ top, left: 0, behavior: "smooth" });
            });
        },
        onScroll: debounce(function() {
            if (this.lock) {
                this.lock = false;
                return;
            }
            const headerHeight = this.$refs.header.offsetHeight,
                { scrollY } = window,
                titles = [];
            titles.push(document.querySelector("#title0"));
            titles.push(document.querySelector("#title1"));
            if (this.goodList.length) {
                titles.push(document.querySelector("#title2"));
            }
            titles.push(document.querySelector("#title3"));
            titles.reduce((initial, title, index) => {
                if (
                    !document.querySelector("#title0") &&
                    !document.querySelector("#title1") &&
                    !document.querySelector("#title2")
                ) {
                    return;
                }
                if (initial) return initial;
                if (
                    scrollY + headerHeight <
                    title.offsetTop + title.offsetHeight
                ) {
                    initial = true;
                    this.navActive = index;
                }
                return initial;
            }, false);
        }, 500),
        showChang() {
            // if (isWeixin()) {
            //     let config = {
            //         latitude: parseFloat(this.storeItems.latitude),
            //         longitude: parseFloat(this.storeItems.longitude),
            //         name: this.storeItems.name,
            //         address: this.storeItems.address + this.system_store.detailed_address
            //     };
            //     wechatEvevt("openLocation", config)
            //         .then(res => {
            //             console.log(res);
            //         })
            //         .catch(res => {
            //             if (res.is_ready) {
            //                 res.wx.openLocation(config);
            //             }
            //         });
            // } else {
            //     if (!this.mapKey)
            //         return this.$dialog.error(
            //             "暂无法使用查看地图，请配置您的腾讯地图key"
            //         );
            //     this.mapShow = true;
            // }
        },
        updateTitle() {
            document.title =
                this.storeInfo.store_name || this.$route.meta.title;
        },
        setOpenShare() {
            var data = this.storeInfo;
            var href = location.href;
            if (this.isLogin) {
                getUserInfo().then((res) => {
                    this.is_real_name = res.data.is_real_name;
                    if (isWeixin()) {
                        href =
                            href.indexOf("?") === -1
                                ? href + "?spread=" + res.data.uid
                                : href + "&spread=" + res.data.uid;
                        var configAppMessage = {
                            desc: data.store_info,
                            title: data.store_name,
                            link: href,
                            imgUrl: data.image,
                        };
                        wechatEvevt(
                            [
                                "updateAppMessageShareData",
                                "updateTimelineShareData",
                                "onMenuShareAppMessage",
                                "onMenuShareTimeline",
                            ],
                            configAppMessage
                        )
                            .then((res) => {
                                console.log(res);
                            })
                            .catch((res) => {
                                if (res.is_ready) {
                                    res.wx.updateAppMessageShareData(
                                        configAppMessage
                                    );
                                    res.wx.onMenuShareAppMessage(
                                        configAppMessage
                                    );
                                    res.wx.updateTimelineShareData(
                                        configAppMessage
                                    );
                                    res.wx.onMenuShareTimeline(
                                        configAppMessage
                                    );
                                }
                            });
                    }
                });
            }
            if (!this.isLogin && isWeixin()) {
                var configAppMessage = {
                    desc: data.store_info,
                    title: data.store_name,
                    link: href,
                    imgUrl: data.image,
                };
                wechatEvevt(
                    [
                        "updateAppMessageShareData",
                        "updateTimelineShareData",
                        "onMenuShareAppMessage",
                        "onMenuShareTimeline",
                    ],
                    configAppMessage
                )
                    .then((res) => {
                        console.log(res);
                    })
                    .catch((res) => {
                        if (res.is_ready) {
                            res.wx.updateAppMessageShareData(configAppMessage);
                            res.wx.onMenuShareAppMessage(configAppMessage);
                            res.wx.updateTimelineShareData(configAppMessage);
                            res.wx.onMenuShareTimeline(configAppMessage);
                        }
                    });
            }
        },
        setShareInfoStatus() {
            this.shareInfoStatus = !this.shareInfoStatus;
            this.posters = false;
        },
        shareCode(value) {
            var that = this;
            getProductCode(that.id).then((res) => {
                if (res.data.code) that.posterData.code = res.data.code;
                value === false && that.listenerActionSheet();
            });
        },
        setPosterImageStatus() {
            var sTop = document.body || document.documentElement;
            sTop.scrollTop = 0;
            this.posterImageStatus = !this.posterImageStatus;
            this.posters = false;
        },
        //产品详情接口；
        productCon() {
            let that = this;
            getProductDetail(that.id)
                .then((res) => {
                    that.$set(that, "gains", res.data.gains);
                    that.$set(that, "gains_num", res.data.storeInfo.gains_num);

                    that.$set(that, "storeInfo", res.data.storeInfo);
                    that.$set(that.attr, "productAttr", res.data.productAttr);
                    that.$set(that, "productValue", res.data.productValue);
                    that.$set(that, "replyCount", res.data.replyCount);
                    that.$set(that, "replyChance", res.data.replyChance);
                    that.reply = res.data.reply ? [res.data.reply] : [];
                    that.$set(that, "reply", that.reply);
                    that.$set(that, "priceName", res.data.priceName);
                    that.posterData.image = that.storeInfo.image_base;
                    that.activity = res.data.activity ? res.data.activity : [];
                    if (that.storeInfo.store_name.length > 30) {
                        that.posterData.title =
                            that.storeInfo.store_name.substring(0, 30) + "...";
                    } else {
                        that.posterData.title = that.storeInfo.store_name;
                    }
                    that.storeSelfMention = res.data.store_self_mention
                        ? true
                        : false;
                    that.posterData.price = that.storeInfo.price;
                    that.posterData.code = that.storeInfo.code_base;
                    that.system_store = res.data.system_store;
                    let good_list = res.data.good_list || [];
                    let goodArray = [];
                    let count = Math.ceil(good_list.length / 6);
                    for (let i = 0; i < count; i++) {
                        var list = good_list.slice(i * 6, i * 6 + 6);
                        if (list.length) goodArray.push({ list: list });
                    }
                    that.mapKey = res.data.mapKey;
                    // that.$set(that, "goodList", goodArray);
                    let navList = ["商品", "评价", "详情"];
                    if (goodArray.length) {
                        // navList.splice(2, 0, "推荐");
                    }
                    that.navList = navList;
                    that.updateTitle();
                    that.DefaultSelect();
                    that.getCartCount();
                    that.getImageBase64();
                    that.setOpenShare();
                })
                .catch((res) => {
                    that.$dialog.error(res.msg);
                    that.$router.go(-1);
                });
        },
        getImageBase64() {
            let that = this;
            imageBase64(this.posterData.image, that.posterData.code)
                .then((res) => {
                    that.posterData.image = res.data.image;
                    that.posterData.code = res.data.code;
                    that.isLogin && that.shareCode();
                })
                .catch(() => {
                    that.isLogin && that.shareCode();
                });
        },
        //默认选中属性；
        DefaultSelect() {
            let productAttr = this.attr.productAttr,
                value = [];
            for (var key in this.productValue) {
                if (this.productValue[key].stock > 0) {
                    value = this.attr.productAttr.length ? key.split(",") : [];
                    break;
                }
            }
            for (let i = 0; i < productAttr.length; i++) {
                this.$set(productAttr[i], "index", value[i]);
            }
            //sort();排序函数:数字-英文-汉字；
            let productSelect = this.productValue[value.sort().join(",")];
            if (productSelect && productAttr.length) {
                this.$set(
                    this.attr.productSelect,
                    "store_name",
                    this.storeInfo.store_name
                );
                this.$set(
                    this.attr.productSelect,
                    "image",
                    productSelect.image
                );
                this.$set(
                    this.attr.productSelect,
                    "price",
                    productSelect.price
                );
                this.$set(
                    this.attr.productSelect,
                    "stock",
                    productSelect.stock
                );
                this.$set(
                    this.attr.productSelect,
                    "unique",
                    productSelect.unique
                );
                this.$set(this.attr.productSelect, "cart_num", 1);
                this.$set(this, "attrValue", value.sort().join(","));
                this.$set(this, "attrTxt", "已选择");
            } else if (!productSelect && productAttr.length) {
                this.$set(
                    this.attr.productSelect,
                    "store_name",
                    this.storeInfo.store_name
                );
                this.$set(
                    this.attr.productSelect,
                    "image",
                    this.storeInfo.image
                );
                this.$set(
                    this.attr.productSelect,
                    "price",
                    this.storeInfo.price
                );
                this.$set(this.attr.productSelect, "stock", 0);
                this.$set(this.attr.productSelect, "unique", "");
                this.$set(this.attr.productSelect, "cart_num", 0);
                this.$set(this, "attrValue", "");
                this.$set(this, "attrTxt", "请选择");
            } else if (!productSelect && !productAttr.length) {
                this.$set(
                    this.attr.productSelect,
                    "store_name",
                    this.storeInfo.store_name
                );
                this.$set(
                    this.attr.productSelect,
                    "image",
                    this.storeInfo.image
                );
                this.$set(
                    this.attr.productSelect,
                    "price",
                    this.storeInfo.price
                );
                this.$set(
                    this.attr.productSelect,
                    "stock",
                    this.storeInfo.stock
                );
                this.$set(
                    this.attr.productSelect,
                    "unique",
                    this.storeInfo.unique || ""
                );
                this.$set(this.attr.productSelect, "cart_num", 1);
                this.$set(this, "attrValue", "");
                this.$set(this, "attrTxt", "请选择");
            }
        },
        //购物车；
        ChangeCartNum(changeValue) {
            //changeValue:是否 加|减
            //获取当前变动属性
            let productSelect = this.productValue[this.attrValue];
            //如果没有属性,赋值给商品默认库存
            if (productSelect === undefined && !this.attr.productAttr.length)
                productSelect = this.attr.productSelect;
            //无属性值即库存为0；不存在加减；
            if (productSelect === undefined) return;
            let stock = productSelect.stock || 0;
            let num = this.attr.productSelect;
            if (changeValue) {
                num.cart_num++;
                if (num.cart_num > stock) {
                    this.$set(this.attr.productSelect, "cart_num", stock);
                    this.$set(this, "cart_num", stock);
                }
            } else {
                num.cart_num--;
                if (num.cart_num < 1) {
                    this.$set(this.attr.productSelect, "cart_num", 1);
                    this.$set(this, "cart_num", 1);
                }
            }
        },
        //将父级向子集多次传送的函数合二为一；
        changeFun(opt) {
            if (typeof opt !== "object") opt = {};
            let action = opt.action || "";
            let value = opt.value === undefined ? "" : opt.value;
            this[action] && this[action](value);
        },
        //打开优惠券插件；
        couponTap() {
            let that = this;
            that.coupons();
            that.coupon.coupon = true;
        },
        changecoupon(msg) {
            this.coupon.coupon = msg;
            this.coupons();
        },
        currentcoupon(res) {
            let that = this;
            that.coupon.coupon = false;
            that.$set(that.coupon.list[res], "is_use", true);
        },
        //可领取优惠券接口；
        coupons() {
            let that = this,
                q = { page: 1, limit: 20, type: 1, product_id: that.id };
            getCoupon(q).then((res) => {
                that.$set(that, "couponList", res.data || []);
                that.$set(that.coupon, "list", res.data);
            });
        },
        //打开属性插件；
        selecAttrTap() {
            this.attr.cartAttr = true;
            this.isOpen = true;
        },
        changeattr(msg) {
            this.attr.cartAttr = msg;
            this.isOpen = false;
        },
        //选择属性；
        ChangeAttr(res) {
            let productSelect = this.productValue[res];
            if (productSelect) {
                this.$set(
                    this.attr.productSelect,
                    "image",
                    productSelect.image
                );
                this.$set(
                    this.attr.productSelect,
                    "price",
                    productSelect.price
                );
                this.$set(
                    this.attr.productSelect,
                    "stock",
                    productSelect.stock
                );
                this.$set(
                    this.attr.productSelect,
                    "unique",
                    productSelect.unique
                );
                this.$set(this.attr.productSelect, "cart_num", 1);
                this.$set(this, "attrValue", res);
                this.$set(this, "attrTxt", "已选择");
            } else {
                this.$set(
                    this.attr.productSelect,
                    "image",
                    this.storeInfo.image
                );
                this.$set(
                    this.attr.productSelect,
                    "price",
                    this.storeInfo.price
                );
                this.$set(this.attr.productSelect, "stock", 0);
                this.$set(this.attr.productSelect, "unique", "");
                this.$set(this.attr.productSelect, "cart_num", 0);
                this.$set(this, "attrValue", "");
                this.$set(this, "attrTxt", "请选择");
            }
        },
        callServe() {
            if (this.$route.query.type == 1) {
                this.$router.replace(
                    `/detail/${this.$route.query.id}?shop_type=${
                        this.$route.query.shop_type
                    }`
                );

                return;
            }
            let goData = {
                type: "callServe",
            };
            window.ReactNativeWebView &&
                window.ReactNativeWebView.postMessage(JSON.stringify(goData));
            return;
        },
        //收藏商品
        setCollect() {
            if (this.$route.query.type == 1) {
                this.$router.replace(
                    `/detail/${this.$route.query.id}?shop_type=${
                        this.$route.query.shop_type
                    }`
                );

                return;
            }
            if (!this.isLogin) {
                let goData = {
                    type: "notLogin",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
                return;
            }

            let that = this,
                id = that.storeInfo.id,
                category = "product";
            if (that.storeInfo.userCollect) {
                getCollectDel(id, category).then(function() {
                    that.storeInfo.userCollect = !that.storeInfo.userCollect;
                });
            } else {
                getCollectAdd(id, category).then(function() {
                    that.storeInfo.userCollect = !that.storeInfo.userCollect;
                });
            }
        },
        goGoods(item) {
            goShopDetail(item).then(() => {
                window.scroll(0, 0);
                // this.$router.push({ path: "/detail/" + item.id });
                this.$router.push({
                    path: `/GoodsDetail?id=${item.id}&token=${
                        this.$route.query.token
                    }&expires_time=${this.$route.query.expires_time}`,
                });
            });
        },
        //  点击加入购物车按钮
        joinCart() {
            const isLogin = this.isLogin;
            if (!isLogin) {
                let goData = {
                    type: "notLogin",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
                return;
            }
            console.log("this.is_real_name", this.is_real_name);
            if (this.is_real_name != 1 && !this.isShow) {
                let goData = {
                    type: "notRealName",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
                return;
            }
            //0=加入购物车
            this.goCat(0);
        },
        /**查询银行卡信息是否完善 */
        bankCard() {
            queryBindStatus({
                token: this.$route.query.token,
            }).then((res) => {
                console.log(res.data.data);
                this.isShow = res.data;
            });
        },
        // 加入购物车；
        goCat(news) {
            const isLogin = this.isLogin;

            if (!isLogin) {
                let goData = {
                    type: "notLogin",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
                return;
            }
            let that = this,
                productSelect = that.productValue[this.attrValue];
            //打开属性
            if (that.attrValue) {
                //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
                that.attr.cartAttr = !that.isOpen ? true : false;
            } else {
                if (that.isOpen) that.attr.cartAttr = true;
                else that.attr.cartAttr = !that.attr.cartAttr;
            }
            //只有关闭属性弹窗时进行加入购物车
            if (that.attr.cartAttr === true && that.isOpen === false)
                return (that.isOpen = true);
            if (
                !this.attr.productSelect.cart_num ||
                parseInt(this.attr.productSelect.cart_num) <= 0
            )
                return that.$dialog.toast({ mes: "请输入购买数量" });
            //如果有属性,没有选择,提示用户选择
            if (
                that.attr.productAttr.length &&
                productSelect === undefined &&
                that.isOpen === true
            )
                return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
            let q = {
                productId: that.id,
                cartNum: that.attr.productSelect.cart_num,
                new: news,
                shop_type: this.shop_type,
                uniqueId:
                    that.attr.productSelect !== undefined
                        ? that.attr.productSelect.unique
                        : "",
            };
            postCartAdd(q)
                .then(function(res) {
                    that.isOpen = false;
                    that.attr.cartAttr = false;
                    if (news) {
                        // console.log('news===》', news);
                        that.asd(res.data.cartId);
                        // that.$router.push({ path: "/order/submit/" + res.data.cartId });
                    } else {
                        // console.log(2);
                        that.$dialog.toast({
                            mes: "添加购物车成功",
                            callback: () => {
                                that.getCartCount(true);
                            },
                        });
                    }
                })
                .catch((res) => {
                    that.isOpen = false;
                    return that.$dialog.toast({ mes: res.msg });
                });
        },
        asd(id) {
            // this.$dialog.toast({ mes: "回调成功" });
            let goData = {
                type: "pay",
                cartId: id,
            };
            // console.log('window===>', window);
            // console.log('window.ReactNativeWebView===>', window.ReactNativeWebView);
            // console.log('goData==》', goData);
            window.ReactNativeWebView &&
                window.ReactNativeWebView.postMessage(JSON.stringify(goData));
        },
        //获取购物车数量
        getCartCount(isAnima) {
            let that = this;
            const isLogin = that.isLogin;
            console.log("isLogin===>", isLogin);
            if (isLogin) {
                getCartCount({ numType: 0 }).then((res) => {
                    that.CartCount = res.data.count;
                    //加入购物车后重置属性
                    if (isAnima) {
                        that.animated = true;
                        setTimeout(function() {
                            that.animated = false;
                        }, 500);
                    }
                });
            }
        },
        //立即购买；
        tapBuy() {
            if (this.$route.query.type == 1) {
                this.$router.replace("/");
                return;
            }
            const isLogin = this.isLogin;
            if (!isLogin) {
                let goData = {
                    type: "notLogin",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
                return;
            }
            console.log("this.is_real_name", this.is_real_name);
            if (this.is_real_name != 1) {
                let goData = {
                    type: "notRealName",
                };
                window.ReactNativeWebView &&
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify(goData)
                    );
                return;
            }
            //  1=直接购买
            this.goCat(1);
        },
        listenerActionSheet() {
            if (isWeixin() === true) {
                this.weixinStatus = true;
            }
            this.posters = true;
        },
        listenerActionClose() {
            this.posters = false;
        },
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.onScroll, false);
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
<style lang="scss" scoped>
.mask {
    z-index: 888 !important;
}
.activity_pin {
    width: auto;
    height: 0.44rem;
    background: linear-gradient(
        90deg,
        rgba(233, 51, 35, 1) 0%,
        rgba(250, 101, 20, 1) 100%
    );
    opacity: 1;
    border-radius: 0.22rem;
    padding: 0 0.2rem;
    margin-left: 0.19rem;
}
.activity_miao {
    width: auto;
    height: 0.44rem;
    padding: 0 0.2rem;
    background: linear-gradient(
        90deg,
        rgba(250, 102, 24, 1) 0%,
        rgba(254, 161, 15, 1) 100%
    );
    opacity: 1;
    border-radius: 0.22rem;
    margin-left: 0.19rem;
}
.iconfonts {
    color: #fff !important;
    font-size: 0.28rem;
    display: block;
}
.activity_title {
    font-size: 0.24rem;
    color: #fff;
}
.activity_kan {
    width: auto;
    height: 0.44rem;
    padding: 0 0.2rem;
    background: linear-gradient(
        90deg,
        rgba(254, 159, 15, 1) 0%,
        rgba(254, 178, 15, 1) 100%
    );
    opacity: 1;
    border-radius: 0.22rem;
    margin-left: 0.19rem;
}
.addressBox .phone {
    margin-left: 1.1rem;
}
.corlor-red {
    color: #fc4141;
}
.store-box {
    padding: 0 0.3rem;
    border-bottom: 1px solid #f5f5f5;
}
.geoPage {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 10000;
}
.product-con .header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 0.96rem;
    font-size: 0.3rem;
    color: #050505;
    background-color: #fff;
    z-index: 11;
    border-bottom: 0.01rem solid #eee;
}
.product-con .header .item {
    position: relative;
    margin: 0 0.35rem;
}
.product-con .header .item.on:before {
    position: absolute;
    width: 0.6rem;
    height: 0.05rem;
    background-repeat: no-repeat;
    content: "";
    background: linear-gradient(to left, #ff3366 0%, #ff6533 100%);
    background: -webkit-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
    background: -moz-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
    bottom: -0.1rem;
}
.product-con .store-info {
    margin-top: 0.2rem;
    background-color: #fff;
}
.product-con .store-info .title {
    font-size: 0.28rem;
    color: #282828;
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 0.01rem solid #f5f5f5;
}
.product-con .store-info .info {
    padding: 0 0.3rem;
    height: 1.26rem;
}
.store-info .icon-jiantou {
    color: #7a7a7a;
    font-size: 0.28rem;
}
.product-con .store-info .info .pictrue {
    width: 0.76rem;
    height: 0.76rem;
}
.product-con .store-info .info .pictrue img {
    width: 100%;
    height: 100%;
    border-radius: 0.06rem;
}
.product-con .store-info .info .text {
    width: 56%;
}
.product-con .store-info .info .text .name {
    font-size: 0.3rem;
    color: #282828;
}
.product-con .store-info .info .text .address {
    font-size: 0.24rem;
    color: #666;
    margin-top: 0.03rem;
}
.product-con .store-info .info .text .address .iconfont {
    color: #707070;
    font-size: 0.18rem;
    margin-left: 0.1rem;
}
.address_tit {
    max-width: 88% !important;
}
.addressTxt {
    width: auto;
    font-size: 0.24rem;
}
.product-con .store-info .info .iconfont {
    font-size: 0.4rem;
}
.product-con .superior {
    background-color: #fff;
    /* margin-top: 0.2rem; */
}
.product-con .superior .title {
    height: 0.98rem;
}
.product-con .superior .title img {
    width: 0.3rem;
    height: 0.3rem;
}
.product-con .superior .title .titleTxt {
    margin: 0 0.2rem;
    font-size: 0.3rem;
    background-image: linear-gradient(to right, #f57a37 0%, #f21b07 100%);
    background-image: -webkit-linear-gradient(
        to right,
        #f57a37 0%,
        #f21b07 100%
    );
    background-image: -moz-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.product-con .superior .slider-banner {
    width: 6.9rem;
    margin: 0 auto;
    padding-bottom: 0.2rem;
}
.product-con .superior .slider-banner .list {
    width: 100%;
    padding-bottom: 0.2rem;
}
.product-con .superior .slider-banner .list .item {
    width: 2.15rem;
    margin: 0 0.21rem 0.2rem 0;
    font-size: 0.26rem;
}
.product-con .superior .slider-banner .list .item:nth-of-type(3n) {
    margin-right: 0;
}
.product-con .superior .slider-banner .list .item .pictrue {
    width: 100%;
    height: 2.15rem;
    position: relative;
}
.product-con .superior .slider-banner .list .item .pictrue img {
    width: 100%;
    height: 100%;
    border-radius: 0.06rem;
}
.product-con .superior .slider-banner .list .item .name {
    color: #282828;
    margin-top: 0.12rem;
}
.product-con .superior .slider-banner .swiper-pagination-bullet {
    background-color: #999;
}
.product-con .superior .slider-banner .swiper-pagination-bullet-active {
    background-color: #f89adf;
}

.mask {
    -webkit-filter: blur(2px);
    -moz-filter: blur(2px);
    -ms-filter: blur(2px);
    filter: blur(2px);
    z-index: 888 !important;
}
.footer .icon-shoucang1 {
    color: #f89adf;
}
.product-con .product-intro .conter div {
    width: 100% !important;
}
.generate-posters {
    width: 100%;
    height: 1.7rem;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    transform: translate3d(0, 100%, 0);
    -webkit-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    -moz-transform: translate3d(0, 100%, 0);
    -o-transform: translate3d(0, 100%, 0);
    transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    opacity: 0;
}
.generate-posters.on {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    opacity: 1;
}
.generate-posters .item {
    flex: 50%;
    -webkit-flex: 50%;
    -ms-flex: 50%;
    text-align: center;
}
.generate-posters .item .iconfont {
    font-size: 0.8rem;
    color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
    color: #5391f1;
}
.noscroll {
    height: 100%;
    overflow: hidden;
}
.contTop {
    padding-top: 0.2rem;
    // padding-bottom: 0.1rem;
}
.goodsCon_attribute {
    height: auto;
    display: flex;
    align-items: center;
    padding: 0.2rem;
    span {
        flex: 1;
    }
}
.goodsCon_title {
    background: #fff;
    margin: 0 0.2rem;
    padding: 0.2rem;
    .goodsCon_title-price {
        display: flex;
        align-items: center;
        > div:nth-of-type(1) {
            font-size: 0.28rem;
            font-weight: bold;
            color: #333333;
            span {
                color: #333333;
                font-size: 0.48rem;
            }
        }
        > div:nth-of-type(2) {
            padding-left: 0.2rem;
            font-size: 0.24rem;
            color: #82848f;
            text-decoration: line-through;
        }
        > div:nth-of-type(3) {
            font-size: 0.24rem;
            color: #82848f;
        }
    }
    .goodsCon_title-name {
        margin-top: 0.16rem;
        font-size: 0.32rem;
        font-weight: bold;
    }
}
.goodsCon_guarantee {
    background: #fff;
    margin: 0.2rem 0.2rem 0;
    padding: 0 0.2rem;

    height: 0.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
        display: flex;
        align-items: center;
        > div:nth-of-type(1) {
            margin-right: 0.3rem;
            // background: #ff6b2f;
            width: 0.4rem;
            height: 0.4rem;
            font-size: 0.22rem;
            color: #fff;
            text-align: center;
            line-height: 0.4rem;
            // background: url("../../assets/images/goodsGuarantee.png") no-repeat;
            background-size: 100%;
        }
        > div:nth-of-type(2) {
            color: #333;
            font-size: 0.26rem;
        }
    }
}
.goodsCon_attr {
    background: #fff;
    margin: 0.2rem 0.2rem 0;
    padding: 0.24rem 0.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .goodsCon_attr-left {
        color: #999999;
        font-size: 0.26rem;
    }
    .goodsCon_attr-cont {
        flex: 1;
        color: #333333;
        font-size: 0.26rem;
    }
    .goodsCon_attr-right {
        color: #333333;
        font-size: 0.26rem;
    }
}

// .goodsCon_evaluation {
//     margin: 0 0.2rem;
//     padding: 0.24rem 0.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     .goodsCon_attr-left {
//         color: #999999;
//         font-size: 0.26rem;
//     }
//     .goodsCon_attr-cont {
//         flex: 1;
//         color: #333333;
//         font-size: 0.26rem;
//     }
//     .goodsCon_attr-right {
//         color: #333333;
//         font-size: 0.26rem;
//     }
// }
.htmlTitle {
    height: 1.2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    margin: 0.2rem 0.2rem 0;
    border-radius: 0.1rem 0.1rem 0 0;
    border-bottom: 1px solid #eee;
    div {
        font-size: 0.32rem;
        color: #333333;
    }

    .on {
        font-size: 0.32rem;
        font-weight: bold;
        color: #333333;
        position: relative;
    }
    .on::after {
        content: "";
        position: absolute;
        bottom: -30%;
        left: 25%;
        width: 0.6rem;
        height: 0.04rem;
        background: #d01112;
        border-radius: 0.04rem;
    }
}
.replyConter {
    background: #fff;
    margin: 0 0.2rem 0;
    padding-bottom: 0.2rem;
}
.span {
    display: flex;
    align-items: center;
    margin-left: 10px;
}
.span img {
    width: 15px;
    height: 9px;
}
.span div {
    padding-left: 5px;
}
.product-con .wrapper .share .money {
    display: flex;
    align-items: center;
}
.product-con .product-intro .title .line-red {
    width: 30px;
    height: 2px;
    background: #d01112;
    border-radius: 2px;
}
.product-con .bnt {
    height: 0.96rem;
}
.product-con .bnt .buy {
    background: #d01112;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.product-con .bnt .joinCart {
    background: #fff;
    border-radius: 0;
    color: #d01112;
    border: 1px solid #d01112;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}
.product-con .footer {
    // padding: 0 0 0 0.7rem;
    padding: 0 0 0 0.3rem;
}
</style>
<style lang="scss">
.html {
    margin: 0 0.2rem 0;
    img {
        width: 100% !important;
        display: block !important;
    }
}
</style>
